import { useTooltip } from "context/TooltipProvider";
import React from "react";
import { addCaseRelation } from "services/caseServices";
import { CaseCreation } from "types";
import { LoadingIcon } from "utils/constant";
import { errorHandlerOnForm } from "utils/helper";

interface Props {
  selectedCase: CaseCreation;
  cases: CaseCreation[];
  onClose: (reload: boolean) => void;
}

const SplitCases: React.FC<Props> = ({ selectedCase, cases, onClose }) => {
  const { showTooltip } = useTooltip();
  const [loading, setLoading] = React.useState(false);
  const [toCase, setToCase] = React.useState<string>();

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();

    setLoading(true);
    addCaseRelation({
      relation_type: "split_from",
      from_case: selectedCase.id ?? 0,
      to_case: toCase ?? 0,
    })
      .then(() => {
        showTooltip("Successfully Submitted!", "success");
        onClose(true);
      })
      .catch((err) => {
        showTooltip(errorHandlerOnForm(err?.response?.data), "error");
        setLoading(false);
      });
  };

  const handleClickOutside = (e: any) => {
    if (e.target.classList.contains("fixed")) {
      onClose(false);
    }
  };

  return (
    <div
      style={{ marginTop: "0px" }}
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm p-4"
      onClick={handleClickOutside}
    >
      <div className="bg-white rounded-lg shadow-lg p-6 w-[600px]">
        <h2 className="text-lg font-semibold text-gray-800">Split Case</h2>
        <form onSubmit={handleSubmit}>
          <div className="rounded-lg  mt-4 ">
            Are you sure you want to split case{" "}
            <span className="font-semibold">
              Prosecutor Reg. No. {selectedCase.prosecutor_registration_number}
            </span>
            ?
          </div>

          <div className="flex flex-col mt-4 ">
            <label className="text-sm text-[#747171] font-[inter] font-[400] flex-col-2 mb-2">
              Select To Case
            </label>
            <select
              className="border border-gray-300 rounded-lg bg-[#F2F2F2] p-2 pr-8 focus:outline-none focus:ring focus:ring-blue-300"
              value={toCase ?? ""}
              onChange={(e) => setToCase(e.target.value)}
            >
              <option value={""}>Select To Case</option>
              {cases
                ?.filter((caseItem) => caseItem?.id !== selectedCase?.id)
                .map((caseItem, index) => (
                  <option key={index} value={caseItem?.id}>
                    Prosecutor Reg No.{" "}
                    {caseItem?.prosecutor_registration_number}
                  </option>
                ))}
            </select>
          </div>

          <div className="mt-6 flex justify-between gap-2">
            <button
              className="px-4 py-2 bg-gray-200 text-gray-800 rounded w-full hover:bg-gray-300"
              onClick={() => onClose(false)}
            >
              Cancel
            </button>
            <button
              type="submit"
              className={`border border-[#E90101] bg-[#E90101] px-10 py-2 text-white 
                              font-[Poppins] cursor-pointer font-[500] w-full
                              text-base rounded-md hover:bg-white hover:text-[#E90101]
                              ${
                                loading ? "opacity-50 cursor-not-allowed" : ""
                              }`}
              disabled={loading}
            >
              {loading ? (
                <div className="flex items-center justify-center">
                  {LoadingIcon}
                  Loading...
                </div>
              ) : (
                "Split"
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SplitCases;
